import React from "react";
import { Button, Modal } from "best-common-react";
import { InvalidEmailListRow } from "../types/emailList.ts";
import styled from "styled-components";

const TableContainer = styled.div`
  overflow: auto;
  max-height: 500px;
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
`;

const Th = styled.th`
  padding: 0.5rem;
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${props => props.theme.colors.white};
  text-align: center;
`;

const Tr = styled.tr`
  border: 1px solid #000;
`;

const Td = styled.td`
  padding: 0.5rem;
  text-align: center;
`;

export type InvalidEmailListUploadModalProps = {
  open: boolean;
  invalidEmailAddress: InvalidEmailListRow[];
  onOmitRows: () => void;
  onClose: () => void;
};

const InvalidEmailListUploadModal: React.FC<InvalidEmailListUploadModalProps> = ({
  open,
  invalidEmailAddress,
  onOmitRows,
  onClose
}) => {
  return (
    <Modal show={open}>
      <Modal.Header>Invalid Email Addresses</Modal.Header>
      <Modal.Body>
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <Th>Row</Th>
                <Th>Email Address</Th>
              </tr>
            </thead>
            <tbody>
              {invalidEmailAddress.map(row => (
                <Tr key={`row-${row.row}`}>
                  <Td>{row.row}</Td>
                  <Td>{row.email}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </TableContainer>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="me-2" onClick={onClose}>
          Close
        </Button>
        <Button variant="danger" onClick={onOmitRows}>
          <i className="fas fa-trash me-2" />
          Omit Rows
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvalidEmailListUploadModal;
